module.exports = __webpack_public_path__ + "87e6f3753a46e179533c6cd1fd66f943.pdf";